import slick from 'slick-carousel';
import Loader from '../class/Loader';

const defaultParams = {
    headerSelector: '',
    vehicleHeaderSelector: '',
    vehicleHeaderTrimSelector: '',
    navigationSelector: '',
    homeSliderList: ''
}

class HomeSlider {
    constructor(selector, params) {
        this.selector = selector;
      this.params = $.extend({}, defaultParams, params)
        this.$slider = null;

    this.$header = null;
    this.$vehicleHeader = null;
    this.$vehicleHeaderContainer = null;
    this.$navigation = null;
    this.$window = $(window);


      this.loader = new Loader('.loaderWrapper')
      this.homeSliderListElement = document.querySelector(this.params.homeSliderList)
      this.homeDotsElement = document.querySelector('.home-slider .slick-dots');
        addEventListener("DOMContentLoaded", (event) => {
          this.$slider = $(this.selector)
          if(document.querySelector('.no-txt'))
              document.querySelector('.no-txt').classList.remove('no-txt');
        });
    }

    init() {



        $().ready(() => {
          this.homeSliderListElement = document.querySelector(this.params.homeSliderList)
          this.homeDotsElement = document.querySelector('.home-slider .slick-dots');
          this.$slider = $(this.selector);
            if (this.$slider.length === 0)
                return;
            if(document.querySelector('.no-txt')) {
              document.querySelector('.no-txt').classList.remove('no-txt');
            }




          this.$slider.slick({
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: $('.home-slider-list').attr('data-slide-speed'),
                fade: true,
                appendDots: $('.js-heroSliderDots'),
                lazyLoad: 'ondemand',
              responsive: [
              { breakpoint: 1200 },
              { breakpoint: 768 },
              { breakpoint: 1300 }
            ]
            })

            $('.home-slider .slick-dots').find('.slick-active').addClass('active');
            setTimeout(this.loader.remove(), 100);
            this.$slider.parent().removeClass('not-loaded');

            if (this.params.vehicleHeaderSelector) {
                this.$vehicleHeader = $(this.params.vehicleHeaderSelector);
                this.$vehicleHeaderContainer = this.$vehicleHeader.find('.container');
            }

          let videoUpdate = function ()  {
            var video = document.querySelector('video')
            console.log(video)

            var width = $(window).width();

            if (width < 1200) {
              video.src=$('#video_mobile_url').val();
            }
            else
            {
              video.src = $('#video_url').val();
            }

            video.type = "video/mp4";
            video.load();
          }
          videoUpdate()

          this.$slider.on('breakpoint',(event, slick, breakpoint) => {
           videoUpdate();
          });

          addEventListener("visibilitychange", (event) => {
            videoUpdate();
          });


            this.$slider.on('beforeChange', (a, b, c, d) => {
                this.updateNavigation(c,d);
            });
          this.$slider.on('afterChange', (event, slick, currentSlide) => {
            var speedtime = this.homeSliderListElement.querySelectorAll('.slick-slide')[currentSlide].querySelector('.home-slide').getAttribute('customSpeed')
            var nextSlide = (currentSlide + 1) % slick.slideCount;

            this.$slider.slick('slickSetOption', 'autoplaySpeed',  speedtime, true);
            $('.home-slider .slick-dots').find('.slick-active').addClass('active');



          });

            this.homeDotsElement = document.querySelector('.home-slider .slick-dots');
        });
    }


    updateNavigation(current,next) {
      let activeSlide = this.homeSliderListElement.querySelectorAll('.slick-slide')[next].querySelector('.home-slide').getAttribute('data-nav-color');

        if(activeSlide == 'inverted'){
          this.homeDotsElement.classList.add('slick-dots__inverted')
        }else{
          this.homeDotsElement.classList.remove('slick-dots__inverted')
        }

        $('.home-slider-list .slick-dots').each(function(){
          $(this).find('li').each(function (index){
            if(next == index){
              $(this).addClass('active');
            }else{
              $(this).removeClass('active');
            }
          });
        });

    }



}

export {
    HomeSlider as
        default
};
